/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancelblack': {
    width: 9,
    height: 8,
    viewBox: '0 0 9 8',
    data: '<g _stroke="#000" _fill="none" fill-rule="evenodd" stroke-linecap="square"><path pid="0" d="M1.425 7.604L8.496.533M1.425.533l7.071 7.071"/></g>'
  }
})
